import { AdminUserIdentityInfoModel } from "./user_identity_info_model.js"
import { RawAdminUserModel } from "./user_model.js";

class RawAdminIdentityUserModel extends RawAdminUserModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: AdminUserIdentityInfoModel,
        weight: 12,
      }
    ]
  }
}
const AdminIdentityUserModel = new RawAdminIdentityUserModel();

export { RawAdminIdentityUserModel, AdminIdentityUserModel }
